import React, { Component } from 'react';
import { path } from 'ramda';
import { withAsyncActions } from 'react-async-client';

import { fullAutoOptions } from 'constants/asyncClient';
import ModalContainer from 'components/modals/ModalContainer';
import ModalCloseButton from 'components/modals/ModalCloseButton';
import { getActionVacancy } from 'actions/asyncActions';
import { ActionVacancyCard } from 'components/sidebars/education/actionVacancy/ActionVacancyCard';

@withAsyncActions({
    getActionVacancy: getActionVacancy.withPayload(({ params: { id } }) => id)
}, fullAutoOptions)
export default class ActionVacancyModal extends Component {
    render() {
        const { modal, close, getActionVacancy: { data, meta }, params: { name } } = this.props;

        const title = path(['names', 0, 'text'], data) || name;
        const footer = <ModalCloseButton close={close} />;

        return (
            <ModalContainer
                meta={meta}
                modal={modal}
                title={title}
                footer={footer}
                className="modal-full card-modal"
            >
                <ActionVacancyCard item={data} />
            </ModalContainer>
        );
    }
}
